<div class="qr-code-container">
  <div
    class="loading-table-overlay-spinner-container"
    *ngIf="!qrCodeUrl; else qr"
  >
    <app-loading-dots size="5px"></app-loading-dots>
  </div>
  <ng-template #qr><img [src]="qrCodeUrl" alt="MFA QR Code" /> </ng-template>
</div>
